<template>
  <!-- eslint-disable-next-line cc-testid/require-testid-prop -->
  <template v-if="vertical === VERTICAL.LIFE_INSURANCE">
    <atoms-card
      class="text-center max-w-full"
      size="md"
      rounded="lg"
      shadow="lg"
    >
      <p class="text-xl font-bold text-black mt-0 mb-4">
        Why invest in Life Insurance?
      </p>

      <hr class="border-0 border-b border-gray-350" />

      <swiper-container
        ref="swiper"
        class="py-8 pointer-events-auto"
        navigation="true"
      >
        <swiper-slide
          v-for="(item, itemIndex) in investInLifeInsurance"
          :key="itemIndex"
        >
          <div class="text-sm text-gray-125 flex flex-col items-center justify-center px-8">
            <component :is="item.component" class="w-16 h-16 my-4" />

            <p class="md:my-4 font-bold">
              {{ item.title }}
            </p>

            <p>
              {{ item.description }}
            </p>
          </div>
        </swiper-slide>
      </swiper-container>
    </atoms-card>

    <V2MoleculesLifeCover />
  </template>

  <template v-else-if="vertical === VERTICAL.PERSONAL_LOANS">
    <V2MoleculesInlineRate
      :options="[
        {
          link: VERTICALS[VERTICAL.PERSONAL_LOANS].formPage,
          label: '$2,001-$5,000',
        },
        {
          link: VERTICALS[VERTICAL.PERSONAL_LOANS].formPage,
          label: '$5,001-$10,000',
        },
        {
          link: VERTICALS[VERTICAL.PERSONAL_LOANS].formPage,
          label: '$10,001-$20,000',
        },
        {
          link: VERTICALS[VERTICAL.PERSONAL_LOANS].formPage,
          label: '$20,001-$30,000',
        },
        {
          link: VERTICALS[VERTICAL.PERSONAL_LOANS].formPage,
          label: '$30,001-$40,000',
        },
        {
          link: VERTICALS[VERTICAL.PERSONAL_LOANS].formPage,
          label: '$40,001-$50,000',
        }
      ]"
    />
  </template>

  <template v-else-if="[VERTICAL.ENERGY, VERTICAL.HOME_LOANS].includes(vertical)">
    <V2MoleculesInlineCardCta
      :vertical="vertical"
      :redirect-url="verticalData?.formPage"
      cta-type="stickyState"
    />
  </template>

  <template v-else>
    <atoms-card
      class="text-center bg-pink-600"
      rounded="lg"
      theme="plain"
      size="md"
    >
      <p class="text-white leading-5">
        Australia: We saved our customers an average of $300* on their annual premium!
      </p>
    </atoms-card>

    <V2MoleculesAgeCta />
  </template>
</template>

<script setup>
import { register } from 'swiper/element/bundle'
import { Navigation } from 'swiper/modules'

register()

defineOptions({
  name: 'V2OrganismContentWidgetsSidebarV1'
})

const props = defineProps({
  vertical: {
    type: String,
    default: ''
  },

  url: {
    type: String,
    default: '/'
  },

  content: {
    type: String,
    default: ''
  }
})

const verticalData = VERTICALS[props.vertical]

const investInLifeInsurance = [
  {
    component: resolveComponent('V2IconsShieldCheck'),
    image: '/images/benefit-1.svg',
    title: 'Protect your loved ones',
    description: 'Safeguard your families financial future by covering costs, such as those during a time of an unexpected loss.'
  },
  {
    component: resolveComponent('V2IconsHeartBeat'),
    image: '/images/benefit-2.svg',
    title: 'Peace of Mind',
    description: 'Know your loved ones will be financially secure if anything were to happen'
  },
  {
    component: resolveComponent('V2IconsClipboard'),
    image: '/images/benefit-3.svg',
    title: 'Prepare for Unexpected Events',
    description: 'Rest assured knowing you have a contingency plans in case of unexpected events'
  }
]

const swiper = ref()
onMounted(() => {
  const el = swiper.value

  if (el) {
    Object.assign(el, {
      modules: [Navigation]
    })
    el.initialize()
  }
})
</script>

<style scoped>
swiper-container {
  --swiper-theme-color: #1E0C39;
  --swiper-navigation-size: 24px;
}
</style>
